import {reduxForm} from 'redux-form';
import { signupUser } from '../../actions/auth_actions';

import Signup from '../../components/Auth/signup'

// Signup form validation. Very simple, password must be same with the passwordConfirm and each
// field should be filled.

function validate(formProps) {
    const errors = {};

    if (!formProps.email) {
        errors.email = 'Please enter an email';
    }

    if (!formProps.password) {
        errors.password = 'Please enter a password';
    }

    if (!formProps.passwordConfirm) {
        errors.passwordConfirm = 'Please confirm password';
    }

    if (formProps.password != formProps.passwordConfirm) {
        errors.password = 'Passwords must match';
    }



    return errors;
}

function mapStateToProps(state) {
    return { errorMessage: state.auth.error }
}

export default reduxForm({
    form: 'signup',
    fields: ['email', 'password', 'passwordConfirm'],
    validate
}, mapStateToProps, { signupUser })(Signup);




// WEBPACK FOOTER //
// ./master/jsx/containers/Auth/signup.jsx